import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export default function CrmActivityTimeline({ items = [] }) {
  return (
    <Card className="border-border">
      <CardHeader><CardTitle>Activity Timeline</CardTitle></CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <p className="text-muted-foreground text-sm">No activities yet.</p>
        ) : (
          <ul className="space-y-3 border-l-2 border-blue-200 pl-4">
            {items.map((a) => (
              <li key={a.id} className="relative">
                <span className="absolute -left-[21px] top-1 w-2.5 h-2.5 rounded-full bg-blue-600" />
                <p className="text-sm font-medium">{a.action?.replace(/_/g, ' ')}</p>
                {a.details && <p className="text-sm text-muted-foreground">{a.details}</p>}
                <p className="text-xs text-muted-foreground">{a.created_at}</p>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
